import { Swiper } from 'swiper';
import { Autoplay, Navigation, EffectFade } from 'swiper/modules';
import * as Globals from '../globals';

export default class HeroNico {
    
    static init() {
        return new HeroNico();
    }

    constructor() {
        this.initVideoUnmute();

        const swiperContainer = document.querySelector('.swiper.hero-nico');

        if (swiperContainer === null) return;

        this.swiperDelay = swiperContainer.getAttribute('data-swiper-delay');
               
        const config = {
            autoHeight: window.innerWidth <= Globals.BREAKPOINT_LG,
            modules: [Navigation, Autoplay, EffectFade],
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
            speed: 1500, 
            autoplay: {
                delay: this.swiperDelay * 1000, // in milliseconds
                disableOnInteraction: false,
            },
        };

        this.swiper = new Swiper(swiperContainer, config);
        this.initProgressbar();

        this.swiper.on('slideChangeTransitionEnd', () => {
            this.resetProgressbars();
            this.initProgressbar();
        });
    }

    initProgressbar() {
        const delaySeconds = this.swiperDelay;
        const swiperDOM = this.swiper.el;
        const activeSlide = swiperDOM.querySelector(".swiper-slide-visible");
        const activeProgressbar = activeSlide.querySelector('.progress-bar');

        activeProgressbar.setAttribute('style', 'transition: width linear ' + delaySeconds + 's; width: 100%;');
    }

    resetProgressbars() {
        const swiperDOM = this.swiper.el;
        const progressbars = swiperDOM.querySelectorAll('.progress-bar');

        progressbars.forEach((bar) => {
            bar.setAttribute('style', 'transition: none; width: 0;');
        });
    }

    initVideoUnmute() {
        const heroes = document.querySelectorAll('.hero-nico.video-portrait');

        heroes.forEach((hero) => {
            const video = hero.querySelector('video');
            const toggle = hero.querySelector('.hero-video-unmute');

            if (!video || !toggle) return;

            const setMuted = (muted) => {
                video.muted = muted;
                toggle.classList.toggle('is-unmuted', !muted);
                toggle.setAttribute('aria-pressed', String(!muted));
                toggle.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
            };

            setMuted(true);

            toggle.addEventListener('click', () => {
                setMuted(!video.muted);
            });
        });
    }
}